import React from 'react';
import classNames from 'classnames';

const Section = ({ children, className, withColumns }) => {
  const contentclassName = classNames({
    'home__section-content': true,
    'home__section-content--split': withColumns,
    [className]: !!className,
  });

  return (
    <section className="home__section">
      <div className={contentclassName}>
        {children}
      </div>
    </section>
  );
};

export default Section;



// WEBPACK FOOTER //
// ./src/modules/home/components/section.js